import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { useAttrs } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'CButton',
  setup(__props) {

const attrs = useAttrs()

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", _mergeProps(_unref(attrs), { class: "c-button" }), [
    _renderSlot(_ctx.$slots, "default")
  ], 16))
}
}

})